import axios from 'axios'
import posthog from 'posthog-js'
import React, { Component } from 'react'
import { ValidatorForm } from 'react-form-validator-core'
import { connect } from 'react-redux'
import 'what-input'

import Cookies from './cookies/Cookies'
import Footer from './footer/Footer'
import Nav from './nav/Nav'

import { setPopupRecord } from '../redux/actions'

import "./layout.css"

const styles = {
  '--background': '#FFFFFF',
  '--background-opaque': 'rgba(255, 255, 255, 0.6)',
  '--surface': '#F5F5F5',
  '--dark': '#2A2A2A',
  '--medium': '#4A4A4A',
  '--light': '#999999',
  '--line': '#E5E5E5',
  '--line-light': '#EEEEEE',
  '--line-dark': '#CCCCCC',
  '--line-opaque': 'rgba(220, 220, 220, 0.6)',
  '--outline': 'rgba(235, 194, 71, 0.3)',
  '--shadow': 'rgba(0, 0, 0, 0.15)',
  '--shadow-light': 'rgba(0, 0, 0, 0.05)',
  '--theme': '#FEC721',
  '--theme-opaque': 'rgba(254, 199, 33, 0.5)',
  '--theme-dark': '#FEC416',
  '--warning': '#EB5547'
}
class Layout extends Component {
  constructor(props) {
    super(props)
    this.dismissCookieWarning = this.dismissCookieWarning.bind(this)
    this.state = {
      showCookieWarning: false
    }
  }
  dismissCookieWarning() {
    this.props.setPopupRecord('cookiesConsent', true)
    this.setState({
      showCookieWarning: false
    })
  }
  componentDidMount() {
    const { popupRecords } = this.props
    this.setState({
      showCookieWarning: !popupRecords.cookiesConsent
    })
    window.scrollTo(0, 0)
    posthog.init("phc_HKZuhBWEaSCoJCOluHGkA14PAd2dhtwkgBc3UzS9YS9", {api_host: 'https://app.posthog.com'})
  }
  render() {
    const { children, footerBorderTop, pageContext, page } = this.props
    const { showCookieWarning } = this.state
    return (
      <div
        id="app-content"
        style={styles}
      >
        <Nav pageContext={pageContext} page={page} />
        {children}
        <Footer borderTop={footerBorderTop} />
        {showCookieWarning && <Cookies dismissCookieWarning={this.dismissCookieWarning} />}
      </div>
    )
  }
}
const mapStateToProps = state => ({
  popupRecords: state.meta.popupRecords
})
const mapDispatchToProps = dispatch => ({
  setPopupRecord: (id, to) => dispatch(setPopupRecord(id, to))
})
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Layout)
